import storage from "@/components/utils/storage";
import { OAuth2Client } from "@720tec/auth";

class AuthService {
  constructor() {
    this.useOAuth2 = process.env.VUE_APP_USE_OAUTH2_PROXY === "true";
    this.oauth2Client = null;
    if (this.useOAuth2) {
      this.oauth2Client = new OAuth2Client({
        authEndpoint: `/oauth2/auth`,
        // authEndpoint: `/oauth2/auth?rd=${encodeURIComponent(
        //   window.location.origin + window.location.pathname
        // )}`,
        appName: "recordings",
        roleClaim: "groups",
        multipleRoleRedirectUrl: null,
      });
    }
  }

  async initAuth() {
    if (this.useOAuth2) {
      return await this.initOAuth2Authentication();
    } else {
      return this.checkStorageAuth();
    }
  }

  async initOAuth2Authentication() {
    try {
      const userInfo = await this.oauth2Client.fetchUserInfo({
        appName: "recordings",
      });
      console.log("✅ Usuario autenticado vía OAuth2-proxy:", {
        email: userInfo.email,
        role: userInfo.role,
        allRoles: userInfo.allRoles,
      });
      storage.saveTokenFromOAuth2(userInfo);
      storage.saveAuthenticated("true");

      console.log("Devolviendo true");

      return true;
    } catch (error) {
      console.error("❌ Error al autenticar con OAuth2-proxy:", error);
      console.warn("⚠️ Redirigiendo a OAuth2 login...");
      window.location.href = `/oauth2/start?rd=${encodeURIComponent(
        window.location.origin + window.location.pathname
      )}`;
      return false;
    }
  }

  checkStorageAuth() {
    const authenticated = storage.loadAuthenticated();
    return authenticated === "true";
  }

  getToken() {
    return storage.loadToken();
  }

  getCurrentUser() {
    return {
      username: storage.loadUsername(),
      role: storage.loadIsRole(),
      group: storage.loadGroup(),
      isAuthenticated: storage.loadAuthenticated() === "true",
    };
  }

  logout() {
    storage.removeItemsSessionStorage();
    if (this.useOAuth2) {
      this.logoutOAuth2();
    } else {
      console.log("✅ Sesión cerrada (flujo antiguo)");
    }
  }

  logoutOAuth2() {
    const keycloakLogoutUrl =
      "http://auth.transport.bio/realms/THT/protocol/openid-connect/logout";
    const redirectUri = encodeURIComponent(window.location.origin);
    const clientId = "oauth2-proxy";
    window.location.href = `/oauth2/sign_out?rd=${encodeURIComponent(
      `${keycloakLogoutUrl}?client_id=${clientId}&post_logout_redirect_uri=${redirectUri}`
    )}`;
  }

  isUsingOAuth2() {
    return this.useOAuth2;
  }
  async getAccessToken() {
    if (this.useOAuth2 && this.oauth2Client) {
      return await this.oauth2Client.getAccessToken();
    }
    return this.getToken();
  }
}
export default new AuthService();
